import React, { FC } from 'react';
import s from './generatedCodesCard.module.scss';
import cn from 'classnames';
import Skeleton, { SkeletonProps } from 'react-loading-skeleton';
interface Props {}
const defaultSkeletonProps: SkeletonProps = {
  baseColor: 'var(--White-Edgar)',
  highlightColor: 'var(--Brainstem-Grey)'
} as const;
export const GeneratedCodesCardLoading: FC<Props> = ({}) => {
  return <div className={s.generatedCodesCard} data-sentry-component="GeneratedCodesCardLoading" data-sentry-source-file="GeneratedCodesCardLoading.tsx">
            <Skeleton width={40} height={40} {...defaultSkeletonProps} circle={true} data-sentry-element="Skeleton" data-sentry-source-file="GeneratedCodesCardLoading.tsx" />
            <div className={s.generatedCodesCard__main}>
                <div className={cn(s.generatedCodesCard__shortId, '_ellipsis')}>
                    <Skeleton width={100} height={'100%'} {...defaultSkeletonProps} data-sentry-element="Skeleton" data-sentry-source-file="GeneratedCodesCardLoading.tsx" />
                </div>
                <div className={s.generatedCodesCard__created}>
                    <Skeleton width={150} height={'100%'} {...defaultSkeletonProps} data-sentry-element="Skeleton" data-sentry-source-file="GeneratedCodesCardLoading.tsx" />
                </div>
            </div>
        </div>;
};